<template>
    <v-card>
        <v-card-title style="background-color: #2b3990">
          <span class="headline white--text">{{ titleForm  }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="3">
                <v-autocomplete
                    label="Vehicle"
                    v-model="newVehicle"
                    :items="vehicleOptions"
                    prepend-icon="local_taxi"
                    :item-text="vehicleText"
                    :item-value="vehicleText"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="12" md="3">
                <v-text-field
                    label="Current Mileage"
                    v-model="newCurrentMileage"

                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="12" md="3" v-if="newVehicle === ' Other '">
                <v-text-field

                  v-model="newOtherVehicle"
                  label="Other"
                  prepend-icon="local_taxi"
                ></v-text-field>
            </v-col>

              <v-col cols="12" sm="12" md="3">
                <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="newDate"
                    label="Date"
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="newDate"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="menu = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu.save(date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <v-text-field
                    label="Service"
                    v-model="newService"

                ></v-text-field>
              </v-col>
             
              <v-col cols="12" sm="12">
                <v-textarea
                    label="Notes"
                    v-model="newNotes"
                    outlined

                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="12">
                <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="newNextAppointment"
                    label="Next Appointment"
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="newNextAppointment"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="menu2 = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu2.save(date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
              </v-col>
              <v-col cols="12" sm="12">
                <v-file-input
                  v-model="newImage"
                  class="pa-2"
                  label="Maintenance Document"
                  show-size
                  filled
                  multiple
                  prepend-icon="mdi-camera"
                  accept="image/*"
                  @change="imgSelected"
                >
                  <template #selection="{ text, index }">
                    <v-chip
                      small
                      label
                      close
                      color="primary"
                      @click:close="deleteChip(index)"
                      >{{ text }}</v-chip
                    >
                  </template>
                </v-file-input>
              </v-col>
              <v-carousel v-if="newImage.length > 0">
                <template
                  v-for="(item, index) in imageDetails"
                >
                  <v-carousel-item :key="index">
                    <v-row
                      class="flex-nowrap"
                      style="height: 100%"
                    >
                      <v-img :src="item.AWSLink">
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center"
                        >
                          <div
                            style="
                              color: #000;
                              padding-top: 30%;
                            "
                          >
                            {{ item.Name }}
                          </div>
                        </v-row>
                      </v-img>
                    </v-row>
                  </v-carousel-item>
                </template>
              </v-carousel>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="white--text" color="#259647" @click="addMaintenance()" v-if="newMaintenance">Save</v-btn
          >
          <v-btn
              fab
              small
              @click="showPrintModal()"
              class="mr-8 mb-2 white--text"
              color="#2b6993"
              elevation="4"
              v-if="editMaintenance"
              >
              <v-icon>print</v-icon>
          </v-btn>
          <v-btn class="primary" @click="updateMaintenance()" v-if="editMaintenance">Update</v-btn
          >
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
        </v-card-actions>
      </v-card>
</template>
<script>
  import axios from 'axios'
  import PrintUtil from "../../../utils/print-util";

  const url = require("@/client_config/config").url;

  export default {
    data: function () {
        return {            
          newVehicles: [],
          newVehicle: "",
          newOtherVehicle: "",
          newDate: "",
          newService: "",
          newNotes: "",
          newDocumentation: "",
          newNextAppointment: "",
          newCurrentMileage: "",
          isLoading: true,
          vehicleText: "",
          menu: false,
          on: false,
          StaffID: this.$route.params.employeeID,
          userState: localStorage.getItem('userState'),
          newImage: [],
          removedDocuments: [],
          uploadImg: [],
          titleForm:"",
          date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          menu2: false,
          maintenanceID: this.$route.params.id,
          token: localStorage.getItem('token'),
        }
    },

    computed: {
      isAuditorRole() {
        return localStorage.getItem("userRole") === 'Auditor'
      },

      newMaintenance() {
        return this.$route.params.action == 'add' ? true : false;
      },

      editMaintenance() {
        return this.$route.params.action == 'edit' ? true : false;
      },

      vehicleOptions() {
        let options = [...this.newVehicles];

        if (this.newVehicle.trim() != '' && !this.newVehicles.includes(this.newVehicle)) {
          options.push(this.newVehicle);
        }

        return options;
      },

      generateDownloadUrl() {      
        return `${url}/vehicleMaintenance/download/${this.maintenanceID}`;
      }
    },

    created() {
      this.getVehicles();

      if (this.maintenanceID) {
        this.viewMaintenance();
      }
    },

    async mounted() {
      window.addEventListener('keydown', async (event) => {
          PrintUtil.handleKeydown(event, this.generateDownloadUrl, this.maintenanceID, this.token, 'vehicleMaintenance');
      });
    },

    beforeDestroy() {
      window.removeEventListener('keydown', (event) => {
          PrintUtil.handleKeydown(event, this.generateDownloadUrl, this.maintenanceID, this.token, 'vehicleMaintenance');
      });
    },

    methods: {
      getVehicles() {
        this.isLoading = true;
        axios.get(`${url}/vehicles/active/${this.userState}`).then(res => {
            this.newVehicles = res.data.vehicles.map(vehicle => `${vehicle.Year + ' ' + vehicle.Make + ' ' + vehicle.Model}` )
                    .sort();

        }).finally(() => this.isLoading = false);
      },

      imgSelected(e) {
        this.uploadImg = e;
      },      

      deleteChip(index) {
            this.removedDocuments.push(this.newImage[index]);
            this.newImage.splice(index, 1);
      },
      
      deleteImages() {
        let vehicleIndex = this.vehicles.findIndex((vehicle) => vehicle._id === this.maintenanceID);
        this.removedDocuments.forEach(document => {
            let documentIndex = this.vehicles[vehicleIndex].documents.findIndex((doc) => doc._id === document.id);
            axios.delete(`${url}/documents/${document.id}`)
            .then(res => {
                if (res.status === 204)  {
                    console.log(document.id + ' has been deleted.');
                }
                this.vehicles[vehicleIndex].documents.splice(documentIndex, 1);
            })
            .catch(err => {
                console.log(err);
            }); 
        });
      },

      viewMaintenance() {
        axios.get(`${url}/vehicleMaintenance/${this.maintenanceID}` ).then(res => {
          const item = res.data.vehicle;

          this.titleForm= "Viewing " + item.Service;
          this.newVehicle = item.Vehicle;
          this.newOtherVehicle = item.OtherVehicle;
          this.newDate = item.Date;
          this.newService = item.Service;
          this.newNotes = item.Notes;
          this.newDocumentation = item.Documentation;
          this.newNextAppointment = item.NextAppointment;
          this.newCurrentMileage = item.CurrentMileage;
          this.maintenanceID = item._id;

          if (item.documents.length > 0) {
            const tempData = [];
            for (let i = 0; i < item.documents.length; i++) {
              let fileExt = item.documents[i].AWSLink.split(".").pop();
              tempData.push({
                name: item.documents[i].Name,
                ext: fileExt,
                id: item.documents[i]._id,
                awsLink: item.documents[i].AWSLink,
              });
            }
            this.newImage = tempData;
            this.newImageLink = this.newImage[0].awsLink;
          }

          this.imageDetails = item.documents;
        })
      },

      close() {
        this.$router.go(-1);
      },

      updateMaintenance() {
        const companyIds = localStorage.getItem('userCompanies');

        let req_body = {
          Vehicle: this.newVehicle,
          OtherVehicle: this.newOtherVehicle,
          Date: this.newDate,
          Service: this.newService,
          Documentation: this.newDocumentation,
          Notes: this.newNotes,
          NextAppointment: this.newNextAppointment,
          CurrentMileage: this.newCurrentMileage,
          Company: JSON.parse(companyIds)
        };

        axios.put(`${url}/vehicleMaintenance/${this.maintenanceID}`, req_body).then((response) => {
          if (response.status === 400) {
            response.json().then(function(data) {
              alert(data.msg);
            });
          }
          
          if (this.uploadImg !== null && this.uploadImg !== undefined) {
            this.saveImg();
            if (this.removedDocuments.length > 0) {
                this.deleteImages();
            }
          }

          this.msg =true;
          this.text ="The maintenance log has been updated successfully.";
        });
        this.close();
      },
      
      saveImg() {
        this.message = "";
        for (let i = 0; i < this.uploadImg.length; i++) {
          this.uploadFiles(this.uploadImg[i]);
        }
      },

      uploadFiles(file) {
        const formData = new FormData();
        formData.append("vehicleMaintenance-img", file);
        var ct = { headers: { "content-type": "multipart/form-data" } };
        axios
          .post(`${url}/vehicleMaintenance/img/uploader/${this.maintenanceID}`, formData, ct)
          .then((res) => {
            if (res.status == 400) {
              res.json().then(function(data) {
                this.text=data.msg;
              });
            }

            let vehicleIndex = this.vehicles.findIndex((vehicle) => vehicle._id === this.maintenanceID);
            this.vehicles[vehicleIndex].documents.push(res.data.document);
          })
          .catch((err) => {
            console.log(err);
          });
      },

      addMaintenance: function() {
        var req_body = {
          Vehicle: this.newVehicle,
          OtherVehicle: this.newOtherVehicle,
          Date: this.newDate,
          Service: this.newService,
          Notes: this.newNotes,
          Documentation: this.newDocumentation,
          NextAppointment: this.newNextAppointment,
          CurrentMileage: this.newCurrentMileage,
          StaffID: this.StaffID,
          CompanyID: this.companyID,
        };

        axios.post(`${url}/vehicleMaintenance`, req_body ).then(res => {
          if (res.status == 400) {
            res.json().then(function(data) {
              this.text=data.msg;
            });
          }
          this.maintenanceID = res.data._id;

          this.msg =true;
          this.text ="The new maintenance log has been added successfully.";
          if (this.uploadImg.length > 0) {
            this.saveImg();
          }
          this.getMaintenances();
        });
        this.close();
      },
      

    async showPrintModal() {
        PrintUtil.showPrintOption(this.generateDownloadUrl, this.maintenanceID, this.token,'vehicleMaintenance');
    },
    },
  }
</script>